export const READING_VERSION_MAPPING = {
  ADV_ANALYSIS_BASIC: 'Advanced Analysis Basic',
  WholeBodyDXA: 'BodyCompositionDXA',
  RANO_ADJUDICATION : '2+1 RANO',
};
